import { useMemoizedFn } from 'ahooks'
import { Table, Typography } from 'antd'

import { GenericalRecord } from '../../../types/utilities'
import { flattenArrayTree, toArray } from '../../../utils/array'
import { ProColumnType, ProColumnUnionType } from '../interface'

export const useSummary = (
  summaryData?: GenericalRecord,
  columns?: ProColumnUnionType<GenericalRecord, GenericalRecord>[],
  expandable?: boolean,
  rowSelection?: boolean
) => {
  return useMemoizedFn(() => {
    if (!(summaryData && columns)) {
      return null
    }

    const pureColumns: ProColumnUnionType<GenericalRecord, GenericalRecord>[] =
      flattenArrayTree(columns).filter(item => !('children' in item))
    const finalColumns: ProColumnType<GenericalRecord, GenericalRecord>[] = []

    if (expandable) {
      finalColumns.push({
        align: 'center',
        dataIndex: '__expandable__'
      })
    }
    if (rowSelection) {
      finalColumns.push({
        align: 'center',
        dataIndex: '__rowSelection__'
      })
    }

    finalColumns.push(...pureColumns)

    const cells = finalColumns.map(({ align, colSpan, dataIndex }, index) => {
      const key = toArray(dataIndex).join('.')
      const value = summaryData[key]

      return (
        <Table.Summary.Cell
          key={dataIndex?.toString() || index}
          align={align}
          colSpan={colSpan}
          index={index}
        >
          <Typography.Text strong type='danger'>
            {index === 0 ? '合计' : value}
          </Typography.Text>
        </Table.Summary.Cell>
      )
    })

    return (
      <Table.Summary>
        <Table.Summary.Row>{cells}</Table.Summary.Row>
      </Table.Summary>
    )
  })
}
